import {ApolloClient, gql, NormalizedCacheObject, useQuery} from '@apollo/client';
import {Query, QueryGetLlmCostSummaryArgs} from '../types/generated/graphql';

/**
 * LLM cost rollup for the Admin Costs page. Reads from the durable
 * `cache_llm` collection server-side (see `agents/llm-cost-summary.ts`),
 * so the dashboard keeps working after BullMQ jobs have expired.
 */
const QUERY_GET_LLM_COST_SUMMARY = gql`
  query getLLMCostSummary($since: String!, $until: String!) {
    getLLMCostSummary(since: $since, until: $until) {
      since
      until
      totalCostUSD
      totalTokens
      callCount
      generatedAt
      daily {
        date
        costUSD
        tokens
        callCount
      }
      byModel {
        model
        costUSD
        tokens
        callCount
      }
      byAgent {
        specialization
        version
        model
        costUSD
        tokens
        callCount
      }
    }
  }
`;

export const useGetLLMCostSummary = (
  client: ApolloClient<NormalizedCacheObject>,
  since: string,
  until: string,
) => {
  type T = Pick<Query, 'getLLMCostSummary'>;
  return useQuery<T, QueryGetLlmCostSummaryArgs>(QUERY_GET_LLM_COST_SUMMARY, {
    client,
    variables: {since, until},
    fetchPolicy: 'cache-and-network',
  });
};
